import { Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './core/services/http/http.service';
import { map } from 'rxjs/operators';

@Component({
	selector: 'bcb-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	systemUser: BehaviorSubject<string | undefined>;
	contactType: Observable<string | undefined>;
	year: string = new Date().getFullYear().toString();

	constructor(private readonly http: HttpService) {
		this.systemUser = this.http.systemUser;
		this.contactType = this.http.entityContact.pipe(
			map((contact) => contact?.type)
		);
	}
}
